const TechnologyTypes = 
{
    Military:
    {
        AirForces:"Air Forces",
        Artillery:"Artillery",
        Cavalry:"Cavalry",
        Infantry:"Infantry",
    },
    Production:
    {
        Farm:"Farm",
        Mine:"Mine",
    },
    Urban:
    {
        Lab:"Lab",
        Temple:"Temple",
        Library:"Library",
        Arena:"Arena",
        Theater:"Theater",
    },
    Special:
    {
        Construction: "Construction",
        Colonization: "Colonization",
        Military: "Military",
        Civil: "Civil",
    },
    Government: "Government",
}

module.exports = TechnologyTypes;